import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

const QRState = (state: RootState) => state.qr;

const selectAllQRs = createSelector(QRState, (state) => state.userQRs);

export const QRSliceSelectors = { selectAllQRs };
